import React from 'react'

import styles from './styles.scss'

interface Props {
  className?: string
  children: Array<any>

  // Set same width to both buttons, use the width of the biggest one
  // Does NOT work if btnMinWidth attribute is set.
  btnSameWidthDynamic?: boolean

  // Set same width to both buttons, use the 50% of the container for each one
  btnSameWidthStatic?: boolean

  // Set the minimum width to buttons containers, so the exact button width depends on it's container's padding.
  // If there is only one button, the button's width should be the same as the container's one.
  // Does NOT work if btnSameWidthStatic attribute is set to TRUE.
  btnMinWidth?: string

  // Revert buttons order if vertical design is active
  revertVerticalOrder?: boolean

  // Force vertical design view if the width of this component is equal or lower than this value
  forceVerticalViewBreakpoint?: number // Units pixels
}

interface State {
  vertical: boolean
  fullWidth: boolean
}

export class ControlButtons extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    window.addEventListener('resize', this.triggerCountPosition)
  }

  state: State = {
    vertical: false,
    fullWidth: false,
  }

  componentDidMount() {
    this.triggerCountPosition()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.triggerCountPosition)
  }

  innerContainer: any
  firstBtnContainer: any
  secondBtnContainer: any
  countPositionTimeoutRef: any

  registerContainer = (container: any) => {
    if (!this.firstBtnContainer) {
      this.firstBtnContainer = container
    } else if (!this.secondBtnContainer) {
      this.secondBtnContainer = container
    }
  }

  triggerCountPosition = () => {
    clearTimeout(this.countPositionTimeoutRef)
    this.countPositionTimeoutRef = setTimeout(this.countPosition, 100)
  }

  countPosition = () => {
    if (this.innerContainer) {
      this.innerContainer.style['flex-direction'] = 'row'

      if (this.firstBtnContainer) {
        this.firstBtnContainer.style.width = 'auto'
        this.firstBtnContainer.style.margin = '0px'
        this.firstBtnContainer.style['min-width'] = ''
      }

      if (this.secondBtnContainer) {
        this.secondBtnContainer.style.width = 'auto'
        this.secondBtnContainer.style.margin = 'auto'
        this.secondBtnContainer.style['min-width'] = ''
      }

      const innerContainerWidth: number = this.innerContainer.offsetWidth

      const newState = { ...this.state }

      if (
        this.props.forceVerticalViewBreakpoint &&
        this.props.forceVerticalViewBreakpoint >= innerContainerWidth
      ) {
        newState.vertical = true
        newState.fullWidth = !!this.props.btnSameWidthStatic
      } else if (this.firstBtnContainer && !this.secondBtnContainer) {
        newState.vertical = false
        newState.fullWidth = false
        if (this.props.btnMinWidth) {
          this.firstBtnContainer.style['min-width'] = this.props.btnMinWidth
        }
      } else if (this.firstBtnContainer && this.secondBtnContainer) {
        const firstBtnHeight: number = this.firstBtnContainer.offsetHeight
        const firstBtnWidth: number = this.firstBtnContainer.offsetWidth
        const secondBtnHeight: number = this.secondBtnContainer.offsetHeight
        const secondBtnWidth: number = this.secondBtnContainer.offsetWidth

        if (this.props.btnSameWidthStatic) {
          this.firstBtnContainer.style['min-width'] = '50%'
          this.secondBtnContainer.style['min-width'] = '50%'
        } else if (this.props.btnMinWidth) {
          this.firstBtnContainer.style['min-width'] = `${this.props.btnMinWidth}px`
          this.secondBtnContainer.style['min-width'] = `${this.props.btnMinWidth}px`
        } else if (this.props.btnSameWidthDynamic) {
          const minWidth: number = Math.max(firstBtnWidth, secondBtnWidth)
          this.firstBtnContainer.style['min-width'] = `${minWidth}px`
          this.secondBtnContainer.style['min-width'] = `${minWidth}px`
        }

        if (this.innerContainer.offsetHeight > Math.max(firstBtnHeight, secondBtnHeight)) {
          newState.vertical = true
          newState.fullWidth = !!this.props.btnSameWidthStatic
        } else {
          newState.vertical = false
          newState.fullWidth = false
        }
      }

      this.innerContainer.style['flex-direction'] = ''

      if (this.firstBtnContainer) {
        this.firstBtnContainer.style.width = ''
        this.firstBtnContainer.style.margin = ''
      }

      if (this.secondBtnContainer) {
        this.secondBtnContainer.style.width = ''
        this.secondBtnContainer.style.margin = ''
      }

      if (
        this.state.vertical !== newState.vertical ||
        this.state.fullWidth !== newState.fullWidth
      ) {
        this.setState(newState)
      }
    }
  }

  render() {
    const componentClassNames = [styles.controlButtons]
    this.props.className && componentClassNames.push(this.props.className)

    const innerContainerClassnames = [styles.innerContainer]
    innerContainerClassnames.push(this.state.vertical ? styles.vertical : styles.horizontal)
    this.state.fullWidth && innerContainerClassnames.push(styles.fullWidth)
    this.props.revertVerticalOrder && innerContainerClassnames.push(styles.revertVerticalOrder)

    const children: Array<any> = []

    this.props.children.forEach((child: any) => {
      if (child) {
        children.push(
          <div ref={this.registerContainer} key={`button_${children.length}`}>
            {child}
          </div>
        )
      }
    })

    return (
      <div className={componentClassNames.join(' ')}>
        <div
          ref={(self: any) => {
            this.innerContainer = self
          }}
          className={innerContainerClassnames.join(' ')}>
          {children}
        </div>
      </div>
    )
  }
}

export default ControlButtons
